import React from "react";
import "./AnswerCard.css";
import { useDispatch, useSelector } from "react-redux";
import {
  selectUIStates,
  setSidebarAnswer,
  setUIStates,
} from "../../redux/features/appData";
import {
  PlatformSource,
  RecentAnswer,
  getDefaultUserAvatar,
} from "winslow-core";
import { EmployeeAvatar } from "./EmployeeAvatar";
import { useValidatedImageUrl } from "../../hooks/useValidatedImageUrl";
import { FeedbackRating } from "../agent-chat/FeedbackRating";

const AnswerCard: React.FC<{
  recentAnswer: RecentAnswer;
  onRatingDelete?: () => void;
}> = ({ recentAnswer, onRatingDelete }) => {
  const uiStates = useSelector(selectUIStates);
  const dispatch = useDispatch();

  const fallbackAdminAvatar = recentAnswer.adminName
    ? getDefaultUserAvatar(recentAnswer.adminName)
    : "";
  const {
    validatedUrl: validatedAdminAvatar,
    isValidating: isValidatingAdminAvatar,
  } = useValidatedImageUrl(recentAnswer.adminAvatar || "", fallbackAdminAvatar);

  return (
    <div
      className="card"
      onClick={() => {
        console.log("answercard click");
        dispatch(setSidebarAnswer({ ...recentAnswer }));
        dispatch(
          setUIStates({
            ...uiStates,
            answerSidebarOpen: true,
          })
        );
      }}>
      <div className="card-header">
        <EmployeeAvatar
          email={recentAnswer.email}
          name={recentAnswer.name}
          avatarUrl={recentAnswer.avatarURL}
        />
        <div className="card-header-text">
          <div className="card-name">{recentAnswer.name}</div>
          <div className="card-title">{recentAnswer.title}</div>
        </div>
      </div>
      {recentAnswer.message?.id && (
        <div
          className="card-rating"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
          }}>
          <FeedbackRating
            messageId={recentAnswer.message.id}
            feedbackRating={recentAnswer.message.feedbackRating as any}
            onRatingDelete={onRatingDelete}
          />
        </div>
      )}
      <div className="card-text-container">
        <div className="card-text">"{recentAnswer.question}"</div>
      </div>

      <div className="card-footer">
        <div className="card-footer-icon">
          {recentAnswer.platformSource === PlatformSource.SLACK && (
            <img src="/icons/slack.svg" alt="Slack Icon" />
          )}
          {recentAnswer.platformSource === PlatformSource.OUTLOOK && (
            <img src="/icons/outlook.svg" alt="Outlook Icon" />
          )}
          {recentAnswer.platformSource === PlatformSource.TEAMS && (
            <img src="/icons/teams.png" alt="Teams Icon" />
          )}
          {(recentAnswer.platformSource === PlatformSource.IOS_MOBILE ||
            recentAnswer.platformSource === PlatformSource.ANDROID_MOBILE ||
            recentAnswer.platformSource === PlatformSource.WEB) && (
            <img src="/icons/winslow-ai-logo.svg" alt="Winslow AI Logo" />
          )}
          {recentAnswer.platformSource === PlatformSource.GMAIL && (
            <img src="/icons/gmail.svg" alt="Gmail Icon" />
          )}
        </div>
        {recentAnswer.adminAvatar && recentAnswer.adminName && (
          <div className="card-admin">
            {isValidatingAdminAvatar ? (
              <div className="admin-avatar avatar-loading">...</div>
            ) : (
              <img
                src={validatedAdminAvatar}
                alt={`${recentAnswer.adminName}'s Avatar`}
                className="admin-avatar"
              />
            )}
            <div className="admin-name">{recentAnswer.adminName}</div>
          </div>
        )}
      </div>
    </div>
  );
};

export default AnswerCard;
